var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProducts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "products_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M0 0h21.504v19.298H0z",
  "data-name": "Rectangle 6973"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19626"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19460"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M25-.001a25 25 0 1 1-25 25 25 25 0 0 1 25-25",
  "data-name": "Path 27386"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19441"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19453"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#products_svg__a)",
  "data-name": "Group 19452",
  transform: "translate(14 14.999)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.752 18.638.66 14.894V4.023l10.092 3.744Z",
  "data-name": "Path 27322"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.75 18.638 10.092-3.744V4.023L10.75 7.767Z",
  "data-name": "Path 27323"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.66 4.023 10.752.66l10.091 3.363",
  "data-name": "Path 27324"
})))))));
export { SvgProducts as ReactComponent };
export default __webpack_public_path__ + "static/media/products.e712c03c2dd191e17881e12f5602dd3f.svg";